import mapProps from '../scripts/utils/map-props';
import Upload from './upload';

export default mapProps(
  [
    'fileList',
  ],
  {
    model: {
      prop: 'fileList',
      event: ['change'],
    },
  }
)(Upload);
